export default "__VITE_PUBLIC_ASSET__f50e7098__"